import { FeatureFlag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useFeature from '@swf/core/hooks/useFeature';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Icon } from '@swf/sports/components';
import BetBuilderIcon from '@swf/sports/components/BetBuilderIcon/BetBuilderIcon';

import { TXTWCL_STAR_SUB, TXTWCL_Star_Sub_selections } from './MarketTitleWithIcons.messages.json';
import styles from './MarketTitleWithIcons.scss';

interface Props {
  title: React.ReactNode;
  isSgmEligible?: boolean;
  isStarSubEnabled?: boolean;
}

const MarketTitleWithIcons: React.FC<Props> = ({ title, isSgmEligible, isStarSubEnabled }) => {
  const { formatMessage } = useRegulatoryIntl();
  const starSubIconLabel = formatMessage(TXTWCL_Star_Sub_selections);
  const isBetBuilderEnabled = useFeature(FeatureFlag.ISPBetBuilder);
  return (
    <span className={styles.marketIconStarSubTitle}>
      {title}
      {isSgmEligible && isBetBuilderEnabled && (
        <div className={styles.container}>
          <BetBuilderIcon isActive={false} />
        </div>
      )}
      {isStarSubEnabled && (
        <div className={styles.marketIconStarSub}>
          <Icon name="star-sub" size="lg" label={starSubIconLabel} />
          <span className={styles.marketIconStarSubTitleBadge} aria-hidden="true">
            <Translation {...TXTWCL_STAR_SUB} />
          </span>
        </div>
      )}
    </span>
  );
};

export default MarketTitleWithIcons;
